import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IssueLifecycleState, IssueLifecycleStates } from '../../models/issue';
import { lifecycleCss } from '../../issue-formatting';

// Lifecycle state (Active / Emerging / Fading / Closed).
//
// Worn as the pill the report dialog offers its severity bands on: a tint, a border in the
// state's own weight, one dark ink, and the label. Lifecycle says what the Issue is doing,
// not how bad it is — loud belongs to severity, and the interaction blue belongs to what the
// user can click. Reading it as a severity would make an Active low-severity Issue look
// worse than a Fading critical one, so the weight runs through the greys rather than a hue.
@Component({
  selector: 'app-lifecycle-chip',
  template: `<span class="lc-chip" [ngClass]="cssClass">{{ labelKey | translate }}</span>`,
  styles: [`
    .lc-chip {
      display: inline-flex; align-items: center; justify-content: center;
      padding: 2px 8px; border-radius: 10px;
      background: #f5f5f5; color: #424242;
      border: 1px solid #bdbdbd;
      font-size: 11px; font-weight: 600; letter-spacing: 0.3px; white-space: nowrap;
    }
    /* One ink on one fill: every state clears AA, and the label always names the state. The
       border carries how live the Issue is, which is a weight rather than a colour. */
    .lc-chip.lc-active   { border-color: #757575; }
    .lc-chip.lc-emerging { border-color: #9e9e9e; }
    .lc-chip.lc-fading   { border-color: #bdbdbd; }
    .lc-chip.lc-closed   { border-color: #e0e0e0; }
  `],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LifecycleChipComponent {
  @Input() state: IssueLifecycleState = IssueLifecycleStates.Active;

  get cssClass(): string { return lifecycleCss(this.state); }
  get labelKey(): string { return '@issueState' + this.state; }
}
